import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import { TopBarFullCtaColors, AudienceUpsellEnums } from '../TopBarFullEnums';
import audienceImage from '../assets/UCS_Audience.png';

const DEFAULT_COPY = defineMessages({
  HEADLINE: {
    id: 'AudienceUpsellRotationTopBarFull.headline',
    defaultMessage: 'Now you can reach consumers around the world!',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'AudienceUpsellRotationTopBarFull.message',
    defaultMessage:
      'Send surveys to people in 100+ countries with our Audience panel.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'AudienceUpsellRotationTopBarFull.ctaText',
    defaultMessage: 'CHOOSE YOUR AUDIENCE',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const NOT_GUAC_COPY = defineMessages({
  HEADLINE: {
    id: 'AudienceUpsellRotationTopBarFull.headlineNotGuac',
    defaultMessage: 'Send your survey to consumers in over 100 countries',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'AudienceUpsellRotationTopBarFull.messageNotGuac',
    defaultMessage: 'See how with our global SurveyMonkey Audience panel.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'AudienceUpsellRotationTopBarFull.ctaTextNotGuac',
    defaultMessage: 'START NOW',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export type AudienceUpsellRotationTopBarFullProps = {
  variation?: AudienceUpsellEnums | null;
};

const VariationToCopy = {
  [AudienceUpsellEnums.NotGuac]: NOT_GUAC_COPY,
};

export const AudienceUpsellRotationTopBarFull: React.FC<AudienceUpsellRotationTopBarFullProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  return (
    <TopBarFull
      headline={t(copy.HEADLINE)}
      message={t(copy.MESSAGE)}
      image={() => <img src={audienceImage} aria-hidden="true" />}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL('/collect/audience/preview', {
        ut_source: 'topbar',
        ut_source2: 'upsell_rotation_audience',
      })}
      ctaNewTab={true}
      ctaColor={TopBarFullCtaColors.alt}
      dismissable={true}
    />
  );
};

export default AudienceUpsellRotationTopBarFull;
